// extracted by mini-css-extract-plugin
export var iconDownloadContent = "index-module--iconDownloadContent--YIpx1";
export var zipDownload = "index-module--zipDownload--sC4+5";